// @owner ClientPlatform

export const brandViolets = {
  shade100: '#f8f1fe',
  shade700: '#8034bf',
  shade800: '#5b1f76',
  shade900: '#9820ee',
} as const;
